(() => {
	angular
		.module('main')
		.controller('JobContractController', JobContractController);

	JobContractController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'$http',
		'$q',
		'jobDataService',
		'messageService',
		'fileUploadService',
		'emailService',
		'userService',
		'newJobsDataService',
		'workflowService',
		'workflowDataService',
		'utilsService'
	];

	function JobContractController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		$http,
		$q,
		jobDataService,
		messageService,
		fileUploadService,
		emailService,
		userService,
		newJobsDataService,
		workflowService,
		workflowDataService,
		utilsService
	) {
		$scope.isJobView = $location.path().includes('/jobs/');
		$scope.isLeadView = $location.path().includes('/leads/');

		if ($scope.isLeadView) {
			$scope.isArchived = true;
		}
		let isFirstShow = true;
		$scope.$on('$viewContentLoaded', () => {
			$scope.isDeleteContractSpinnningWheelActive = false;
			$scope.isSendContractSpinnningWheelActive = false;
			$scope.isSignSpinningWheelActive = false;
			if ($scope.isLeadView) {
				getLead($routeParams.leadId);
			} else if ($scope.isJobView) {
				getJobInfo($routeParams.jobId);
			}

			$scope.gdprEnabled = userService.userData.isGdprEnabled;
		});

		clearAttachments();
		$(document).on('shown.bs.modal', '#sendContractModal', () => {
			if (isFirstShow) {
				isFirstShow = false;
				if (
					$scope.sendMessage.task !== undefined &&
					$scope.sendMessage.isDisable
				) {
					$scope.attachmentsData.attachments = JSON.parse(
						JSON.stringify($scope.sendMessage.task.taskEmail.storedAttachments)
					);
				} else {
					$scope.attachmentsData = {
						attachments: [],
						filesSize: 0
					};
				}
			}
		});
		function getLead(id, showTaskId = '') {
			$http({
				method: 'GET',
				url: `/api/user/lead/${id}`,
				params: {
					showTaskId
				}
			}).then(
				result => {
					$scope.jobId = result.data.job.id;
					$scope.isArchived = result.data.archived;
					if (result.data.job.primaryContact.email) {
						$scope.contactEmail = result.data.job.primaryContact.email;
					}
					if ($scope.jobId !== undefined) {
						getContactsInformation($scope.jobId);
					}
				},
				error => {
					const { errorCode, data } = error.data;
					if (errorCode === 701) {
						redirectToJobLead(data);
					}
				}
			);
		}

		function getJobInfo(id, showNewTaskId = '') {
			$http({
				method: 'GET',
				url: '/protected/rest/jobs/view',
				params: {
					id,
					showNewTaskId
				}
			}).then(
				result => {
					$scope.jobId = result.data.id;

					if (result.data.primaryContact.email) {
						$scope.contactEmail = result.data.primaryContact.email;
					}
					if ($scope.jobId !== undefined) {
						getContactsInformation($scope.jobId);
					}
				},
				error => {
					const { errorCode, data } = error.data;
					if (errorCode === 702) {
						redirectToJobLead(data);
					}
				}
			);
		}

		function redirectToJobLead(data) {
			$location.path(
				`/${data.redirectTo}s/view/${data.redirectId}/contracts/${
					$routeParams.contractId
				}`
			);
		}

		$scope.$parent.$watch('attachmentsDataContract', (newValue, oldValue) => {
			if (newValue && newValue !== oldValue) {
				$scope.attachmentsData = newValue;
			}
		});

		function getContactsInformation(id) {
			$http
				.get(
					`/protected/rest/contracts/get/view/${id}/${$routeParams.contractId}`
				)
				.then(result => {
					if (result.data) {
						const { contract, company } = result.data;

						$scope.contract = contract;
						if (contract.contactEmail) {
							$scope.contactEmail = contract.contactEmail;
						}
						$scope.company = company;

						if (contract.jobAttachments && contract.jobAttachments.length) {
							fileUploadService.setAttachmentsFromServer(
								contract.jobAttachments
							);
						}
					}
				});
		}

		$scope.showSign = function() {
			$('#signModal').modal('show');
		};

		$scope.submitSign = function(id) {
			if ($('#signModalForm').checkValidity()) {
				$scope.isSignSpinningWheelActive = true;

				const signatureObj = {
					contractId: $scope.contract.id,
					jobId: $scope.contract.jobId,
					textSignature: $scope.textSignature
				};

				$http({
					method: 'POST',
					url: '/protected/rest/contract/photographer/signature',
					data: signatureObj
				})
					.then(
						data => {
							getContactsInformation($scope.jobId);
							// $scope.contract.photographerSignature = $scope.textSignature;
						},
						() => {}
					)
					.finally(() => {
						delete $scope.textSignature;
						$('#signModal').modal('hide');
						$scope.isSignSpinningWheelActive = false;
					});
			} else {
				$('#signModalSubmit').click();
			}
		};

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}
		$scope.modalClose = function() {
			isFirstShow = true;
			if ($scope.isLeadView) {
				$rootScope.updateLeadView();
			} else if ($scope.isJobView) {
				$rootScope.updateJobView();
			}
		};
		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = '';
			}

			if (state === false) {
				$scope.attachmentsData = {
					attachments: [],
					filesSize: 0
				};
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		let clientsEmailTimer;
		$scope.clientEmails = [];

		function emailSearchRequest(search) {
			jobDataService
				.searchClient(search)
				.then(result => findClientSuccessCallback(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		function findClientSuccessCallback(client) {
			if (client) {
				$scope.clientEmails.length = 0;
				client.forEach(item => $scope.clientEmails.push(item));
			}
		}

		$scope.setEmail = function(site) {
			let stringEmail = angular.copy(site.name);
			stringEmail = stringEmail.substring(
				stringEmail.indexOf('(') + 1,
				stringEmail.length - 1
			);

			$scope.sendMessage.emailCc = stringEmail;
			$scope.emailCcObj = Object.assign({ email: stringEmail }, site);
		};

		$scope.$watchCollection('sendMessage', newValue => {
			if (newValue) {
				if (!newValue.emailCc) {
					$scope.sendMessage.emailCc =
						angular.element('#sendContractMessageData_emailCc').val() || '';
				}

				if (
					$scope.sendMessage &&
					$scope.sendMessage.emailCc &&
					$scope.sendMessage.emailCc.length > 0
				) {
					if (clientsEmailTimer != null) {
						clearTimeout(clientsEmailTimer);
					}

					clientsEmailTimer = setTimeout(
						emailSearchRequest($scope.sendMessage.emailCc),
						500
					);
				} else {
					clearTimeout(clientsEmailTimer);
				}
			}
		});
		$scope.deleteModalContract = function() {
			if ($scope.isArchived) {
				messageService.showToaster('e_6', 'lead');
			} else {
				$('#deleteModal').modal();
			}
		};
		$scope.deleteContract = function(id) {
			$scope.isDeleteContractSpinnningWheelActive = true;

			$http({
				method: 'POST',
				url: `/protected/rest/contracts/view/delete/${id}`
			}).then(
				result => {
					deleteCallback(result.data);
				},
				() => {
					$scope.isDeleteContractSpinnningWheelActive = false;
				}
			);
		};

		$scope.showNextModal = function(selectModal, nextModal, e) {
			utilsService.showNextModal(selectModal, nextModal, e);
		};

		function deleteCallback(data) {
			const { errorCode, errorMessage } = data;
			if (
				errorCode === 102 &&
				errorMessage === 'Contract is assigned for task'
			) {
				$('#deleteModal').modal('hide');
				// We do not have proper message from the backend, so we make a wrapper and get predefined error from service
				messageService.showToaster('e_1', 'contract');
			} else if (errorMessage) {
				toastr.error(errorMessage, 'Error');
			} else {
				messageService.showToaster('s_0', 'contract');
				if ($scope.contract.inLead === false) {
					$location.path(`/jobs/view/${$routeParams.jobId}`);
				} else {
					$location.path(`/leads/view/${$scope.contract.leadId}`);
				}
			}
			$scope.isDeleteContractSpinnningWheelActive = false;
		}

		$scope.showSendContract = function() {
			const contractUrl = '/protected/rest/job/contract/sources';
			$http({
				method: 'GET',
				url: contractUrl
			}).then(result => {
				$scope.contractSendSource = result.data;
				$scope.contractEmailTemplates =
					$scope.contractSendSource.emailTemplates;
				if (
					$scope.contractEmailTemplates &&
					$scope.contractEmailTemplates.length > 0
				) {
					const template = $scope.contractEmailTemplates.find(
						item => item.emailTemplateType === 'CONTRACT_EMAIL_TEMPLATE'
					);

					$scope.chosenContractEmail =
						template || $scope.contractEmailTemplates[0];
					$scope.setContractEmailTemplate(template.id);
				}

				delete $scope.sendMessage;
				$scope.sendMessage = {};
				// $scope.sendMessage.emailTo = $scope.primaryContactEmail || '';
				const rootEmail = $rootScope.primaryContact
					? $rootScope.primaryContact.email || ''
					: '';
				$scope.sendMessage.emailTo = $scope.contactEmail || rootEmail;

				$scope.sendMessage.emailCc = '';

				$('#sendContractModal').modal('show');
			});
		};

		$scope.setContractEmailTemplate = function(id) {
			const contractSetEmailCallback = function(data) {
				$scope.contractEmailTemplate = angular.copy(data);
				if (data.storedAttachments && data.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(
							data.storedAttachments
						)
					};
				} else {
					clearAttachments();
				}
			};
			$scope.getEmailTemplates(id, contractSetEmailCallback);
		};

		// START maybe need delete it
		$scope.getEmailTemplates = function(id, callback) {
			if (id != null) {
				const emailTemplateUrl = `/protected/rest/settings/email_template/get/${id}?forSend=${true}`;
				$http({
					method: 'GET',
					url: emailTemplateUrl
				}).then(result => {
					callback(result.data);
				});
			}
		};
		// END :maybe need delete it

		// Email methods
		$scope.retrySendMail = function() {
			if ($scope.jobId !== undefined) {
				getContactsInformation($scope.jobId);
			}
			emailService.callLastEmailFn();
		};
		function saveChangeTask(task) {
			$scope.isSendContractSpinnningWheelActive = true;
			task.jobId = $scope.sendMessage.jobId;
			if (
				$scope.chosenContractEmail !== undefined &&
				$scope.chosenContractEmail !== null
			) {
				task.taskEmail.emailTemplateId = $scope.chosenContractEmail.id;
			}
			if (task.overdueDays !== null) {
				task.overdueDays = parseInt(task.overdueDays.match(/\d+/)[0], 10);
			}
			task.taskEmail.subject = $scope.contractEmailTemplate.subject;
			task.taskEmail.text = $scope.contractEmailTemplate.text;
			task.taskEmail.storedAttachments = null;
			task.taskEmail.base64Attachments = null;
			$scope.uploadedAttachments = null;
			if (
				$scope.attachmentsData.attachments &&
				$scope.attachmentsData.attachments.length !== 0
			) {
				task.taskEmail.storedAttachments = $scope.attachmentsData.attachments.filter(
					attachment => attachment.id
				);
				$scope.uploadedAttachments = $scope.attachmentsData.attachments.filter(
					attachment => !attachment.id
				);
			}

			if ($scope.uploadedAttachments && $scope.uploadedAttachments.length) {
				fileUploadService
					.convertFileToSave($scope.uploadedAttachments)
					.then(convertedFilesArr => {
						task.taskEmail.base64Attachments = convertedFilesArr;
						workflowDataService
							.saveTask(task)
							.subscribe(
								data => changeTaskState(data.tasks[data.taskToAnimate]),
								error => errorSaveTask(error.data)
							);
					})
					.catch(error => console.log(error));
			} else {
				workflowDataService
					.saveTask(task)
					.subscribe(
						data => changeTaskState(data.tasks[data.taskToAnimate]),
						error => errorSaveTask(error.data)
					);
			}
		}
		function errorSaveTask(data) {
			$scope.isSendContractSpinnningWheelActive = false;
			workflowService.errorSaveTask(data);
		}
		const saveTaskWithAttachments = task => {
			prepareEmailAttachments(task.taskEmail).then(
				result => {
					task.taskEmail = result;
					saveChangeTask(task);
				},
				error => {
					scope.button_disabled = false;
				}
			);
		};
		const prepareEmailAttachments = taskEmail => {
			const deferred = $q.defer();
			taskEmail.attachmentsData = $scope.attachmentsData;
			const isAttachments =
				taskEmail.attachmentsData &&
				taskEmail.attachmentsData.attachments.length;

			if (!isAttachments) {
				deferred.resolve(taskEmail);
				return deferred.promise;
			}

			const { attachments, filesSize } = taskEmail.attachmentsData;
			const maxSize = 10; // 10Mb

			if (filesSize > maxSize) {
				messageService.showToaster('w_0', 'attachments');
				deferred.reject('Attachments size exceeds the limit');
				return deferred.promise;
			}

			let uploadedAttachments, storedAttachments;

			if (attachments.length) {
				uploadedAttachments = attachments.filter(attachment => !attachment.id);
				$scope.storedAttachmentsForMail = attachments.filter(
					attachment => attachment.id
				);
			}

			taskEmail.storedAttachments =
				storedAttachments && storedAttachments.length
					? storedAttachments
					: null;

			if (uploadedAttachments && uploadedAttachments.length) {
				fileUploadService
					.convertFileToSave(uploadedAttachments)
					.then(convertedFilesArr => {
						$scope.base64AttachmentsForMail = convertedFilesArr;
						deferred.resolve(taskEmail);
					})
					.catch(error => console.log(error));
			} else {
				deferred.resolve(taskEmail);
			}

			delete taskEmail.attachmentsData;
			return deferred.promise;
		};

		$scope.sendContractEmail = function() {
			if ($scope.sendMessage.task !== undefined) {
				saveChangeTask($scope.sendMessage.task);
			} else {
				$scope.isSendContractSpinnningWheelActive = true;
				const maxSize = 10; // 10Mb

				if (
					$scope.attachmentsData &&
					$scope.attachmentsData.filesSize > maxSize
				) {
					messageService.showToaster('w_0', 'attachments');
					$scope.isSendContractSpinnningWheelActive = false;
					return false;
				}

				$scope.contractEmailTemplate.text = $rootScope.addMaiStyling(
					$scope.contractEmailTemplate.text
				);
				const url = '/protected/rest/job/contract/send';

				const obj2save = angular.copy($scope.sendMessage);
				const emailCC2save = $scope.showCcField ? obj2save.emailCc : '';

				const forSend = {
					emailTo: $scope.sendMessage.emailTo,
					emailCc: emailCC2save,
					emailText: $scope.contractEmailTemplate.text,
					emailSubject: $scope.contractEmailTemplate.subject,
					contractText: $scope.contract.text,
					contractId: $routeParams.contractId,
					jobId: $scope.contract.jobId,
					templateId: $scope.contractEmailTemplate.id
				};

				const formData = new FormData();
				angular.forEach(forSend, (value, key) => {
					console.debug(`key: ${key}  | value: ${value}`);
					formData.append(key, value);
				});
				if ($scope.attachmentsData.attachments !== undefined) {
					const storedFiles = $scope.attachmentsData.attachments.filter(
						file => file.id
					);
					const uploadedFiles = $scope.attachmentsData.attachments.filter(
						file => !file.id
					);

					angular.forEach(uploadedFiles, (value, key) => {
						formData.append(`attachments[${key}]`, value);
					});

					angular.forEach(storedFiles, (value, key) => {
						formData.append(`storedAttachments[${key}]`, value.id);
					});
				}

				$scope.disableBtnOnSend = true;
				$http({
					method: 'POST',
					url,
					data: formData,
					transformRequest: angular.identity,
					headers: {
						'Content-Type': undefined
					}
				}).then(
					result => {
						$scope.disableBtnOnSend = false;
						$scope.showCcField = false;
						if ($rootScope.updateLeadView) {
							// changeTaskState($scope.sendMessage.task);
							$rootScope.updateLeadView();
						}

						if ($rootScope.updateJobView) {
							// changeTaskState($scope.sendMessage.task);
							$rootScope.updateJobView();
						}
						isFirstShow = true;
						messageService.showToaster('s_4', 'jobView');

						$('#sendContractModal').modal('hide');

						$scope.$evalAsync();

						for (const prop in $scope.sendMessage) {
							$scope.sendMessage[prop] = '';
						}

						if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
							if ($scope.attachmentsData.attachments.length) {
								$scope.attachmentsData.attachments.length = 0;
							}
						}
						$scope.isSendContractSpinnningWheelActive = false;
					},
					({ status, data }) => {
						isFirstShow = false;
						$scope.isSendContractSpinnningWheelActive = false;
						$scope.disableBtnOnSend = false;
						const path = $location.path();
						const errorMessage = data.errorMessage;

						if (status >= 400 && status < 500 && errorMessage) {
							if (status == 423) {
								const limit = $rootScope.isUserTrial ? 50 : 150;
								return messageService.showToaster(
									'e_4',
									'generalValidation',
									limit
								);
							} else if (errorMessage.includes('Email address inactive')) {
								messageService.showToaster(
									'e_1',
									'generalValidation',
									$scope.sendMessage.emailTo
								);
							} else if (
								errorMessage.includes(
									'Email text should contain a contract link'
								)
							) {
								messageService.showToaster('e_0', 'contract');
							} else if (errorMessage.includes('Lead is archived')) {
								messageService.showToaster('e_5', 'lead');
							} else if (path.includes('jobs')) {
								messageService.showToaster('e_0', 'contract');
							} else {
								messageService.showToaster('e_2', 'general', errorMessage);
							}
						} else {
							messageService.showToaster('e_0', 'general');
						}
					}
				);
			}
		};
		function changeTaskState(task) {
			task.completed = true;
			newJobsDataService
				.changeTaskState($scope.sendMessage.jobId, task)
				.finally(() => {
					$rootScope.dnd.canMove = true;
				})
				.subscribe(
					data => {
						toastr.clear();
						$scope.isSendContractSpinnningWheelActive = false;
						messageService.showToaster('i_0', 'jobView');
						task = Object.assign(task, data);
						handleTask(task, $scope.sendMessage.sortedTasksArr);
						isFirstShow = true;
						messageService.showToaster('s_4', 'clients');
						$('#sendContractModal').modal('hide');
					},
					result => {
						toastr.clear();
						messageService.showDefaultErrorMessage(result);
					}
				);
		}
		const handleTask = (task, taskTypes) => {
			if (task.dateItem) {
				task.dateItem = task.dateItem.toLowerCase();
			}

			if (task.due && !task.hasDue) {
				// for old workflows
				task.hasDue = true;
			}

			if (!task.action && task.taskEmail) {
				// for old workflows
				task.action = 'SEND_EMAIL';
			}

			if (task.calendarEventType === 'MAIN_SHOOT') {
				const {
					startDate,
					finishDate,
					startTime,
					finishTime,
					location
				} = $scope.job;
				task.location = location;
				task.startDate = startDate;
				task.endDate = finishDate;
				task.startTime = startTime;
				task.endTime = finishTime;
			} else if (task.calendarEvent) {
				const {
					startDate,
					endDate,
					startTime,
					endTime,
					location,
					clientId
				} = task.calendarEvent;
				task.location = location;
				task.startDate = startDate;
				task.endDate = endDate;
				task.startTime = startTime;
				task.endTime = endTime;
				task.sendEmails = clientId ? task.calendarEvent.sendEmails : false;

				if (
					task.startDate &&
					(task.startTime === null || task.finishTime === null)
				) {
					task.allday = true;
				}
			}

			task.overdueDays = workflowService.calcTaskOverdue(task.overdueDays);
			task.taskViewDue = workflowService.getTaskViewDue(task, taskTypes);
			task.taskDueDefault =
				task.defaultTask && task.dueDate ? task.dueDate : null;
			if ($scope.isLeadView) {
				$rootScope.updateLeadView();
			} else if ($scope.isJobView) {
				$rootScope.updateJobView();
			}
		};
		$scope.disableDragDrop = function() {
			return true;
		};

		$(document).on('show.bs.modal', '#sendContractModal', () => {
			$scope.$broadcast('addedFileEvent');
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/job/jobContractController.js